import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DynamicCrudService } from '../../../___LOGIC/__crud/dynamic-crud.service';

@Component({
  selector: 'app-crud',
  templateUrl: './crud.component.html',
  styleUrls: ['./crud.component.css']
})
export class CrudComponent implements OnInit {

  @Input() crudConfig: { 
    tableName: string; 
    apiUrl: string;
    props: any;
  };

  columns: any[] = [];
  data: any[] = [];
  displayedData: any[] = [];
  editingRow: any = null;
  foreignKeys: { [key: string]: any[] } = {};

  currentPage: number = 1;
  pageSize: number = 10;

  columns2 = [
    {
      columnName: "test",
      dataType: "varchar",
      value: null
    }
  ];

  constructor(private http: HttpClient,private dynamicCrudService: DynamicCrudService) {}

  ngOnInit(): void {
    this.crudConfig = {
      tableName: 'answer',
      apiUrl: 'https://dashboard.voyjaleas.com/api-dashboard/crud/crud.php?queryId=GET&queryParam1=',
      props: []
    }
    this.dynamicCrudService.setCurrentStatus('read');
    this.initializeTable();
  }

  // Initialize table by fetching properties and records
  initializeTable(): void {
    this.dynamicCrudService.setLoading(true);
    const { apiUrl, tableName } = this.crudConfig;
    debugger
    this.http.get(`${apiUrl}${tableName}`).subscribe(
      (response: any) => {
        this.columns = response.props; // Properties of the table
        this.crudConfig.props = response.props;
        this.data = response.records; // Data rows
        this.updatePagination();
        this.loadForeignKeys();
        this.dynamicCrudService.setLoading(false);
      },
      (error) => {
        this.dynamicCrudService.setLoading(false);
        console.error('Error fetching table schema:', error)
      }
    );
  }

  // Update displayed data for the current page
  updatePagination(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.displayedData = this.data.slice(start, end);
  }

  // Navigate to the next page
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  // Navigate to the previous page
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  // Calculate the total number of pages
  get totalPages(): number {
    return Math.ceil(this.data.length / this.pageSize);
  }

  // Load foreign key options for FK_ID fields
  loadForeignKeys(): void {
    this.columns.forEach((column) => {
      if (column.columnName.startsWith('FK_ID_')) {
        const referencedTable = column.columnName.replace('FK_ID_', '');
        this.http.get(`${this.crudConfig.apiUrl}${referencedTable}`).subscribe(
          (response: any) => {
            this.foreignKeys[column.columnName] = response.records;
          },
          (error) => console.error(`Error fetching FK data for ${referencedTable}:`, error)
        );
      }
    });
  }

  // Add a new row
  addRow(): void {
    this.dynamicCrudService.setCurrentStatus('create');
    /* const newRow: any = {};
    this.columns.forEach((column) => {
      newRow[column.columnName] = null;
    });
    this.data.unshift(newRow);
    this.editingRow = newRow;
    this.updatePagination(); */
  }

  // Edit an existing row
  editRow(row: any): void {
    this.editingRow = { ...row };
    this.dynamicCrudService.setCurrentStatus('update');
    this.loadDataToCrud();
  }

  // Save a row (create or update)
  saveRow(row: any): void {
    const { apiUrl, tableName } = this.crudConfig;
    const isNew = !row.id;

    if (isNew) {
      this.http.post(`${apiUrl}/${tableName}`, row).subscribe(
        () => {
          this.initializeTable();
          this.editingRow = null;
        },
        (error) => console.error('Error creating row:', error)
      );
    } else {
      this.http.put(`${apiUrl}/${tableName}/${row.id}`, row).subscribe(
        () => {
          this.initializeTable();
          this.editingRow = null;
        },
        (error) => console.error('Error updating row:', error)
      );
    }
  }

  // Cancel editing
  cancelEdit(): void {
    this.editingRow = null;
    this.initializeTable();
  }

  // Delete a row
  deleteRow(row: any): void {
    const { apiUrl, tableName } = this.crudConfig;
    if (confirm('Are you sure you want to delete this row?')) {
      this.http.delete(`${apiUrl}/${tableName}/${row.id}`).subscribe(
        () => this.initializeTable(),
        (error) => console.error('Error deleting row:', error)
      );
    }
  }

  loadDataToCrud(){
    for(let obj of this.crudConfig.props){
      obj.value = this.editingRow[obj.columnName];
    }
  }

  isCurrentStatus(s){
    return this.dynamicCrudService.isCurrentStatus(s);
  }
  
  isLoading(){
    return this.dynamicCrudService.isLoading();
  }

  processOp(event){
    if(event.status == 'ok'){
      this.dynamicCrudService.setCurrentStatus('read');
      this.initializeTable();
    }

  }
}